import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  Typography,
  Avatar,
  Grid,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  Divider,
  Chip
} from "@mui/material";

import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import LogoutIcon from "@mui/icons-material/Logout";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import getBrand from "../../brands/getBrand";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CustomAxios from "../../utils/CustomAxios";
import { updateId, updateMobileno } from "../../Redux/user";


export const UserProfile = () => {
    const [brand, setBrand] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.user.id);
    const reduxMobileno = useSelector((state) => state.user.mobileno);
    const [mobileNo, setMobileNo] = useState("");
    const [showOrders, setShowOrders] = useState(false);
    const [orders, setOrders] = useState([]);
    const [orderHistory, setOrderHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
      const hub = localStorage.getItem("selected_hub");

      if (hub) {
        const loadedBrand = getBrand();
        setBrand({ ...loadedBrand }); // important: spread to force new object
      }
    }, []);
    console.log("Selected hub:", localStorage.getItem("selected_hub"));
    console.log("Brand returned:", getBrand());

    useEffect(() => {
      const storedMobile = localStorage.getItem("mobileno");
      if (storedMobile) {
        setMobileNo(storedMobile);
        return;
      }
      if (reduxMobileno) {
        setMobileNo(reduxMobileno);
        localStorage.setItem("mobileno", reduxMobileno);
        return;
      }

      const effectiveUserId = userId || localStorage.getItem('id');
      if (effectiveUserId) {
        CustomAxios.get("get_users/")
          .then((res) => {
            const users = res?.data?.users || [];
            const currentUser = users.find(
              (u) => String(u.id) === String(effectiveUserId)
            );
            if (currentUser?.mobileno) {
              setMobileNo(currentUser.mobileno);
              localStorage.setItem("mobileno", currentUser.mobileno);
              dispatch(updateMobileno(currentUser.mobileno));
            }
          })
          .catch((err) => {
            console.error("Failed to fetch user mobileno from backend:", err);
          });
      }
    }, [reduxMobileno, userId, dispatch]);
    const fetchOrders = async () => {
        // Check both Redux and localStorage for userId
        const effectiveUserId = userId || localStorage.getItem('id');
        if (!effectiveUserId) {
            setError("User ID not found");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await CustomAxios.post(`get_orders/${effectiveUserId}/`, {
                currentLimit: 10,
                currentOffset: 0,
                oldLimit: 10,
                oldOffset: 0
            });

            // Check if response has the expected structure
            if (response.data?.response) {
                setOrders(response.data.currentOrders || []);
                setOrderHistory(response.data.oldOrders || []);
            } else if (response.data?.error) {
                // Backend returned an error (e.g., "Something went wrong" when no orders found)
                // When NotFound is raised, it gets caught and returns {"error":"Something went wrong"}
                // Treat this as "no orders" scenario
                setOrders([]);
                setOrderHistory([]);
                setError(null);
            } else {
                // Unexpected response structure
                setError("Failed to fetch orders");
            }
        } catch (err) {
            console.error("Error fetching orders:", err);
            const errorMessage = err?.response?.data?.detail || err?.response?.data?.error || err?.message || "";
            const statusCode = err?.response?.status;
            
            // Check if it's a "no orders found" error (404 or message contains "no orders")
            if (statusCode === 404 || 
                errorMessage.toLowerCase().includes("no orders found")) {
                // User has no orders - not an error, just empty arrays
                setOrders([]);
                setOrderHistory([]);
                setError(null);
            } else {
                // Real error occurred
                setError(errorMessage || "Failed to fetch orders");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleOrdersClick = () => {
        if (!showOrders && orders.length === 0 && orderHistory.length === 0) {
            fetchOrders();
        }
        setShowOrders(!showOrders);
    };

    const getStatusColor = (status) => {
        const statusColors = {
            pending: "#F59E0B",
            confirmed: "#3B82F6",
            delivery_partner_assigned: "#8B5CF6",
            delivery_partner_accepted: "#8B5CF6",
            order_picked_up: "#10B981",
            delivered: "#10B981",
            cancelled: "#EF4444",
        };
        return statusColors[status] || "#6B7280";
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const logout = () => {
        localStorage.clear();
        navigate("/");
    };
  return (
    <Box style={{minHeight: "100vh",
        background: brand?.backgroundColor ?? "rgb(255, 218, 179)",
        display: "flex",
        flexDirection: "column",}}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 2, md: 3 },
          background: "#fff",
          borderBottom: "1px solid #E5E7EB",
          height: { xs: "56px", md: "72px" },
        }}
      >
        <Button
          startIcon={<ArrowBackIosIcon sx={{ fontSize: "14px",color: brand?.theme?.textPrimary || "#111827" }}/>}
          onClick={() => navigate("/home/user_management")}
          sx={{ textTransform: "none" }}
        >
          
        </Button>
        <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827" }}>
          Profile
        </Typography>
        <Box />
      </Box>
          {/* Profile Header */}
          <Box sx={{padding:'16px'}}>
              
      <Card style={{ borderRadius: "8px", padding: 16, marginBottom: 16 }}>
        <Box style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Avatar
            style={{
              width: 60,
              height: 60,
              backgroundColor: "#9c27b0",
              fontSize: 22
            }}
          >
            {/* S */}
          </Avatar>

          <Box>
            {/* <Typography style={{ fontSize: 14, fontWeight: 600 }}>
              Sriram
            </Typography> */}
            <Typography style={{ fontSize: 12, color: "#666" }}>
              {mobileNo}
            </Typography>
          </Box>
        </Box>
      </Card>

      {/* Quick Actions */}
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        <Grid item xs={6}>
          <Card 
            style={actionCardStyle}
            onClick={handleOrdersClick}
          >
            <ShoppingBagIcon fontSize="small" />
            <Typography style={{ fontSize: 14, textAlign: "center" }}>Your Orders</Typography>
          </Card>
        </Grid>

        <Grid item xs={6}>
          <Card style={actionCardStyle}>
            <SupportAgentIcon fontSize="small" />
            <Typography style={{ fontSize: 14 }}>Help & Support</Typography>
          </Card>
        </Grid>
      </Grid>

      {/* Orders Section */}
      {showOrders && (
        <Card style={{ borderRadius: "8px", padding: 16, marginBottom: 16 }}>
          <Typography variant="h6" style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>
            Your Orders
          </Typography>

          {loading && (
            <Box style={{ display: "flex", justifyContent: "center", padding: 20 }}>
              <CircularProgress size={24} />
            </Box>
          )}

          {error && (
            <Typography style={{ color: "#EF4444", fontSize: 14, padding: 16, textAlign: "center" }}>
              {error}
            </Typography>
          )}

          {!loading && !error && (
            <>
              {/* Current Orders */}
              {orders.length > 0 && (
                <Box style={{ marginBottom: 24 }}>
                  <Typography style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: "#666" }}>
                    Active Orders
                  </Typography>
                  {orders.map((order, index) => (
                    <Card
                      key={order.id || index}
                      style={{
                        marginBottom: 12,
                        padding: 12,
                        borderRadius: "8px",
                        border: "1px solid #E5E7EB",
                        cursor: "pointer"
                      }}
                      onClick={() => navigate(`/order-tracking/${order.order_id}`)}
                    >
                      <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <Box style={{ flex: 1 }}>
                          <Typography style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>
                            Order #{order.order_id?.slice(-8) || order.id}
                          </Typography>
                          <Typography style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                            {formatDate(order.created_on)}
                          </Typography>
                          <Typography style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
                            ₹{parseFloat(order.total_amount || 0).toFixed(2)}
                          </Typography>
                        </Box>
                        <Chip
                          label={order.status?.replace(/_/g, " ").toUpperCase() || "PENDING"}
                          size="small"
                          style={{
                            backgroundColor: getStatusColor(order.status),
                            color: "#fff",
                            fontSize: "10px",
                            fontWeight: 600
                          }}
                        />
                      </Box>
                    </Card>
                  ))}
                </Box>
              )}

              {/* Order History */}
              {orderHistory.length > 0 && (
                <Box>
                  <Typography style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: "#666" }}>
                    Order History
                  </Typography>
                  {orderHistory.map((order, index) => (
                    <Card
                      key={order.id || index}
                      style={{
                        marginBottom: 12,
                        padding: 12,
                        borderRadius: "8px",
                        border: "1px solid #E5E7EB",
                        cursor: "pointer"
                      }}
                      onClick={() => navigate(`/order-tracking/${order.order_id}`)}
                    >
                      <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <Box style={{ flex: 1 }}>
                          <Typography style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>
                            Order #{order.order_id?.slice(-8) || order.id}
                          </Typography>
                          <Typography style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                            {formatDate(order.created_on)}
                          </Typography>
                          <Typography style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
                            ₹{parseFloat(order.total_amount || 0).toFixed(2)}
                          </Typography>
                        </Box>
                        <Chip
                          label={order.status?.replace(/_/g, " ").toUpperCase() || "DELIVERED"}
                          size="small"
                          style={{
                            backgroundColor: getStatusColor(order.status),
                            color: "#fff",
                            fontSize: "10px",
                            fontWeight: 600
                          }}
                        />
                      </Box>
                    </Card>
                  ))}
                </Box>
              )}

              {orders.length === 0 && orderHistory.length === 0 && !loading && (
                <Typography style={{ color: "#666", fontSize: 14, textAlign: "center", padding: 20 }}>
                  Looks like you haven't ordered anything yet!
                </Typography>
              )}
            </>
          )}
        </Card>
      )}

      {/* Menu List - Hide when orders are shown */}
      {!showOrders && (
        <Card style={{ borderRadius: "8px", marginBottom: 16 }}>
          <List disablePadding>
            <MenuItem
              icon={<LocationOnIcon fontSize="small" />}
              label="Saved Addresses"
              onClick={() => navigate("/saved-addresses")}
            />
            {/* <MenuItem
              icon={<CardGiftcardIcon fontSize="small" />}
              label="Rewards"
            /> */}
          </List>
        </Card>
      )}

      {/* Logout - Hide when orders are shown */}
      {!showOrders && (
        <Button
          fullWidth
          variant="contained"
          startIcon={<LogoutIcon />}
          style={{
            backgroundColor: "#ff4d4f",
            borderRadius: "8px",
            padding: 14,
            fontSize: 14,
            textTransform: "none"
          }}
          onClick={() => {
              logout()
          }}
        >
          Logout
        </Button>
      )}
          </Box>
    </Box>
  );
};

function MenuItem({ icon, label, onClick }) {
  return (
    <ListItem
      button
      onClick={onClick}
      style={{
        padding: "12px 16px",
        borderBottom: "1px solid #eee"
      }}
    >
      <ListItemIcon style={{ minWidth: 36 }}>
        {icon}
      </ListItemIcon>

      <ListItemText
        primary={
          <Typography style={{ fontSize: 14 }}>
            {label}
          </Typography>
        }
      />

      {/* Arrow */}
      <ChevronRightIcon style={{ color: "#999" }} />
    </ListItem>
  );
}

const actionCardStyle = {
  borderRadius: "8px",
  padding: 20,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 8,
  cursor: "pointer"
};
